import { render, staticRenderFns } from "./WaiterVideoStream.vue?vue&type=template&id=680877bc&"
import script from "./WaiterVideoStream.vue?vue&type=script&lang=ts&"
export * from "./WaiterVideoStream.vue?vue&type=script&lang=ts&"
import style0 from "./WaiterVideoStream.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports